export default "__VITE_ASSET__P1iCMBcN__"